import { journeyAction, settingsFormSchema } from "./base";
import { JourneyActionCallback as JourneyActionCallbackBase } from "atlas-shared";

export const JourneyActionCallback = journeyAction({
  ...JourneyActionCallbackBase,
  settings_form: settingsFormSchema({
    elements: [{ ref: "queue_id" }, { ref: "asterisk_sound_id" }],
  }),
  icon: "Voice",
});
